import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';

import type { UpdateBuilderExperienceRequest } from 'app/typings/core/builder/experienceForm';
import { apiMutation } from 'app/utils/request/api';

import { CORE_QUERY_KEYS, ENDPOINTS } from '.';

type UpdateBuilderExperienceParams = {
  experienceId: number;
  payload: UpdateBuilderExperienceRequest;
};

export function useUpdateBuilderExperience(hotelId: number) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      experienceId,
      payload,
    }: UpdateBuilderExperienceParams) =>
      apiMutation(
        'PATCH',
        {
          path: ENDPOINTS.updateExperience,
          params: {
            id: hotelId.toString(),
            experienceId: experienceId.toString(),
          },
        },
        payload
      ) as Promise<void>,
    onSuccess: async () => {
      // awaited so that the modal closes once the list is refreshed
      await queryClient.invalidateQueries({
        queryKey: [CORE_QUERY_KEYS.builderExperiences, { id: hotelId }],
      });
      message.success('Activity successfully updated');
    },
    onError: () => {
      message.error('Error saving activity');
    },
  });
}
